export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} 件目 / {2}件',
    noResultsText: '検索結果が見つかりません。',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: '1ページあたりの行数：',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: '1ページあたりの件数：',
    itemsPerPageAll: 'すべて',
    nextPage: '次のページ',
    prevPage: '前のページ',
    firstPage: '一ページ目',
    lastPage: '最後のページ',
  },
  datePicker: {
    itemsSelected: '{0}日付選択',
  },
  noDataText: 'データはありません。',
  carousel: {
    prev: '前のビジュアル',
    next: '次のビジュアル',
  },
  calendar: {
    moreEvents: 'さらに{0}',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
  observation: {
    freePlanAlertMessage: 'スタンダードプランにアップグレードすると、最大5件まで登録することができます。',
    accumulatedTemperature: '有効積算温度',
    accumulatedTemperatureList: '有効積算温度一覧',
    startDateCalculation: '積算開始日',
    endDateCalculation: '積算終了日',
    lowerLimitTemperature: '下限温度',
    registerAndEditAccumulatedTemperaturePoints: '有効積算温度計算地点の登録/編集',
    period: '期間',
    accumulatedLowerLimitTemperature: '積算下限温度',
    deleteAccumulatedTemperatureLocation: '「{fieldName}」の積算気温観測点を削除してもよろしいですか？',
    soilMoisture: '土壌水分',
    soilTemperature: '地温',
    precipitation: '降水量',
    soilMoistureList: '土壌水分一覧',
    maxRegisterCount: '（最大 {count} 件）',
    soilConditionVeryWet: '過湿',
    soilConditionWet: '適湿',
    soilConditionDry: '乾燥',
    soilConditionVeryDry: '過乾',
    drainage: '土性',
    registerAndEditSoilMoisturePoints: '土壌水分計算地点の登録/編集',
    soilMoistureConditionGood: '砂壌土',
    soilMoistureConditionSlightlyBad: '埴壌土',
    soilMoistureConditionBad: '埴土',
    soilMoistureConditionSandyLoam: '砂壌土',
    soilMoistureConditionClayLoam: '埴壌土',
    soilMoistureConditionClay: '埴土',
    deleteSoilMoistureLocation: '「{fieldName}」の土壌水分観測点を削除してもよろしいですか？',
    deletedField: '< 圃場は削除されました >',
    validateForStartDateBeforeYesterday: '開始日は少なくとも1日前である必要があります',
    validateForStartEndDateOrder: '終了日は開始日よりも後である必要があります',
    validateForStartEndDuration: '開始日と終了日は{day}日以内である必要があります',
    validateForStartNowDuration: '開始日は現在から見て{day}日以内である必要があります',
  },
  caster: {
    rtkInfo: 'RTK補正情報',
    rtkLog: '通信ログ',
    myBaseStationStatus: 'マイ基準局ステータス',
    howToSetupRtkBase: '他社製品から「マイ基準局」に補正情報を送信する場合',
    howToSetupRtkRover: '他社製品にて「マイ基準局」から補正情報を受信する場合',
    host: 'ホスト',
    port: 'ポート',
    mountpoint: 'マウントポイント',
    derivedPassthroughLabel: '（無変換）',
    derivedPassthroughCaption: '基準局の補正情報をそのまま配信します。通常はこちらをご利用ください',
    derivedMsm4Label: '（互換性）',
    derivedMsm4Caption: 'MSM4形式に変換して配信します。最新形式 (MSM7等) で不安定な受信機向け',
    derivedLegacyLabel: '（旧型受信機向け）',
    derivedLegacyCaption: '旧形式 (1004/1012) に変換して配信します。GPS+GLONASSのみ',
    derivedNote:
      '補正情報が受信できない・FIXしない場合は _MSM4 / _LEGACY をお試しください。当社以外の基準局を接続されている場合は所定の出力が行われない場合があります。',
    messageTypesTitle: '配信メッセージタイプ（技術情報）',
    messageTypesIntro:
      '受信機メーカー様などから「基準局はどの電文（メッセージタイプ）を配信していますか」と確認された場合は、接続するマウントポイントに応じて以下をご案内ください。',
    messageTypesPassthrough:
      '基準局の出力をそのまま配信します。当社基準局（AgriBus-GMiniR）の場合: RTCM 3.3 / MSM4+MSM7（1074・1077 GPS / 1084・1087 GLONASS / 1094・1097 Galileo / 1124・1127 BeiDou）毎秒 ＋ 1005（基準局位置）・1008（アンテナ情報）・1230（GLONASSコード位相バイアス）。他社基準局の場合は当該機器の設定に従います',
    messageTypesMsm4:
      'RTCM 3.3 / MSM4 に正規化して配信します: 1074（GPS）・1084（GLONASS）・1094（Galileo）・1114（QZSS）・1124（BeiDou）毎秒（基準局が受信している衛星システムのみ）＋ 1006・1033・1230 を5秒周期',
    messageTypesLegacy:
      '旧形式（RTCM 3.1 相当）で配信します: 1004（GPS L1/L2）・1012（GLONASS L1/L2）毎秒 ＋ 1006・1008 を5秒周期（1033・1230 は配信しません）。観測時刻（タイムタグ）は整数秒に整列して配信するため、整数秒のタイムタグを前提とする受信機でもご利用いただけます',
    baseStation: 'マイ基準局用',
    rover: '移動局',
    userId: 'ユーザーID',
    ntripUserId: 'NtripユーザーID',
    ntripPassword: 'Ntripパスワード',
    showCaption: '表示する',
    statusTab: 'ステータス',
    qualityTab: '品質グラフ',
    mapTab: '地図',
    logTab: '接続ログ',
    settingsTab: '設定',
    baseShort: '基準局',
    casterServer: '配信サーバー',
    roverShort: '移動局',
    receiving: '受信中',
    stale: '受信停滞',
    noConnection: '未接続',
    lastReceivedAt: '最終受信',
    disconnectedAt: '切断',
    summaryTitle: '基準局の受信状況',
    lastSnapshotNote: '切断前の最終値',
    noStatsData: '基準局からのデータ受信がありません',
    bytesRate: '転送量',
    messagesPerSecond: 'メッセージ数',
    epochInterval: 'エポック間隔',
    uptime: '接続時間',
    decodeErrors: 'デコードエラー',
    basePosition: '基準局位置',
    antenna: 'アンテナ',
    satellites: '衛星数',
    signals: '信号数',
    meanCnr: '平均C/N0',
    msgType: 'メッセージ',
    msgCount: '回数',
    msgInterval: '周期',
    msgLastSeen: '最終受信',
    cnrChart: '平均C/N0 (dB-Hz)',
    satsChart: '衛星数',
    rateChart: '転送量 (bytes/秒)',
    epochChart: 'エポック間隔 (ミリ秒)',
    noHistoryData: '履歴データがまだありません',
    noTrackData: '移動局のGGA記録がありません',
    baseline: '基線長',
    fixQuality: 'Fix品質',
    ggaPoints: '記録点数',
    logBaseTitle: '基準局の接続',
    logRoverTitle: '移動局の接続',
    startAt: '開始',
    endAt: '終了',
    inSession: '接続中',
    userAgentLabel: 'クライアント',
    logNote: '表示されるのは直近24時間の記録です',
  },
  print: {
    field: {
      fillSetting: '圃場を塗りつぶす',
      backgroundWhiteColorSetting: '背景を白',
      backgroundNoColorSetting: '背景なし',
      printText: '印刷',
      showFieldName: '圃場名を表示',
    },
  },
  sortOptions: {
    title: '並び順',
    field: {
      name: '圃場名',
      createdAt: '登録年月日',
      lastModifiedDateTime: '更新年月日',
    },
  },
  fieldElevation: {
    title: '高低差マップ',
    cantBuildBecauseNoTask: '作業履歴が存在しないので高低差マップを作成することができません',
    nowBuilding: '作成中... （圃場の面積によっては作成に時間がかかる場合があります）',
    updatedAt: '作成日時',
    meshSize: 'メッシュサイズ',
    taskFetchLimit: '参照データ量',
    taskDateRange: '作業範囲',
    taskPointCount: '作業ポイント数',
    editButton: '編集',
    createButton: '作成',
    needStandardPlan: '高低差マップ作成はスタンダードプランが必要です',
    taskFetchLimitHint: '高低差が出ない場合は増やします。ノイズが多い場合は減らします。',
    creationFailedMessage: '高低差マップ生成に失敗しました',
    gnssStatus: 'GNSS状態',
    elevationRange: '標高レンジ',
    optionSetting: 'オプション設定 (beta)',
    minValue: '最小値',
    maxValue: '最大値',
    minIgnoreCaption: 'この値以下の標高は無視されます',
    maxIgnoreCaption: 'この値以上の標高は無視されます',
    minValueNeedError: '最小値を設定してください',
    maxValueNeedError: '最大値を設定してください',
    minValueRangeError: '最小値は最大値より小さくしてください',
    maxValueRangeError: '最大値は最小値より大きくしてください',
    invalidOptionSettingError: '無効なオプション設定が指定されました',
    dateRangeInput: '日付範囲指定',
    oldestTaskDateInput: '開始日',
    newestTaskDateInput: '終了日',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'GNSS取得元',
    GeneralMainSettingGnssSourceInternal: '端末内蔵GNSS',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB接続GNSS',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth接続GNSS',
    GeneralMainSettingGnssSourceTcpPort: '内部ポート通信',
    GeneralMainSettingGnssSourceNtripClient: 'Ntripクライアント (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: '入力が必要です',
  ResetPasswordTitle: 'パスワードのリセット・再発行',
  ResetPasswordButton: 'パスワードのリセット',
  ResetPasswordDescription:
    '登録しているメールアドレス宛にパスワードのリセット・再発行のリンクが記載されたメールが届きます。メールの指示に従ってパスワードのリセット・再発行を行ってください。',
  ValidationBadEmail: '正しいEmailアドレスを入力してください',
  ChangePasswordButton: 'パスワードを変更',
  CreatePasswordButton: 'パスワードを作成',
  UnitTitle: '表示単位',
  UnitMetric: 'メートル法',
  UnitImperial: 'ヤード・ポンド法',
  UnitJpUnitsOfArea: '日本の面積単位',
  UnitThUnitsOfArea: 'タイの面積単位',
  NickNameHint: '表示する名前',
  SendMeNews: 'メールアドレスあてに最新情報を送付する',
  FreePlanDisplayName: 'フリープラン',
  StandardPlanDisplayName: 'スタンダードプラン',
  ChangePasswordTitle: 'パスワードの変更',
  CreatePasswordTitle: 'パスワードの作成',
  CurrentPasswordHint: '現在のパスワード',
  NewPasswordHint: '新しいパスワード',
  SignInButton: 'ログイン',
  ToResetPasswordButton: 'パスワードを忘れた場合',
  DocFormFieldDetailFieldNameHint: '圃場名',
  DocFormTaskRecordDetailFieldNameHint: '作業記録の名称',
  DocFormTaskRecordDetailDescriptionHint: '備考',
  DocFormTabNameTaskRecordList: '作業履歴',
  DocFormTabNameRefLineList: 'ガイダンス基準線',
  DocFormTabNameGridPointsList: 'メッシュデータ',
  DocFormTabNameFieldList: '圃場',
  DocFormFieldRegisteredDateFormatBase: '登録年月日: {createDate}',
  DocFormMenuItemSignOut: 'ログアウト',
  DocFormFieldDetailDescriptionHint: '備考',
  StandardPlanIsNeededDialogMessage:
    '本機能はスタンダードプラン（30日間の無料試用が可能）を定期購入していただくことでお使いいただけます。',
  SelectPlanDialogTitle: 'プランの選択',
  SelectPlanDialogRecommend: 'おすすめ',
  SelectPlanDialogYearPlan: '年額プラン',
  SelectPlanDialogYearPlanGreatValue: '（2ヶ月分お得）',
  SelectPlanDialogYearMonth: '月額プラン',
  StandardPlanPriceForMonthBatch: '年間購読料',
  StandardPlanPricePerMonth: '/月',
  StandardPlanPricePerYear: '/年',
  StandardPlanPriceForYearNotice: '※12ヶ月分まとめてのお支払いとなります',
  SelectPlanSubscribeYear: '30日間のお試しを開始',
  SelectPlanSubscribeMonth: '30日間のお試しを開始',
  selectPlanDataViewNote:
    '※ご解約後、約1ヶ月以内に契約を再開されなかった場合、解約前に記録されたデータは表示されなくなります（2026年10月1日以降に適用）。必要なデータは契約期間中にエクスポートしてください。',
  DefaultRefLineTypeStraight: '直線',
  DefaultRefLineTypeCurved: '曲線',

  customSelectAll: '全て選択',
  customUnSelectAll: '全て解除',
  customRegistration: '登録',
  customUpdate: '更新',
  customSearch: '検索',
  customDelete: '削除',
  customAllow: '承認',
  customDeny: '辞退',
  customDefault: 'デフォルト',
  customSelected: '選択中',
  customSelectThis: '選択する',
  customArea: '面積',
  customNotAvailable: '利用できません',
  customEdit: '編集',
  customCancel: 'キャンセル',
  customNone: 'なし',
  customClose: '閉じる',
  customFieldDrawHint:
    '地図をクリックして圃場の頂点を追加し、チェックボタンで確定します（戻るボタン / BackSpaceキーで直前の点を削除）',
  customBack: '戻る',
  customRefresh: '更新',
  customUpload: 'アップロード',
  customPriceIncludingTax: '料金（税込）',
  customPay: 'お支払い',
  customCancelContract: '解約',
  customConfirmReally: '本当によろしいですか？',
  customRememberMe: '保存する',
  customLogin: 'ログイン',
  customNowLoggingIn: 'ログイン中...',
  customEmail: 'メールアドレス',
  customPassword: 'パスワード',
  customUser: 'ユーザー',
  customUserSettings: 'ユーザー設定',
  customSentEMailMessage: 'メールを送信しました。',
  customNewPasswordReInput: '新しいパスワードを再入力',
  customValidationPasswordMinLength: 'パスワードは最低でも {length} 文字必要です',
  customValidationPasswordMaxLength: '長すぎます',
  customValidationPasswordNotMatch: 'パスワードが一致しません',
  customChangePasswordSuccess: 'パスワードが変更されました',
  customGoToLoginPageTitle: 'ログイン画面に戻る',
  customYouDontHaveAccount: 'アカウントをお持ちでない場合',
  customRegisterAgriBusWeb: 'AgriBus-Webに登録',
  customChange: '変更する',
  customLanguage: '言語',
  customSaveAction: '保存',
  customSaveSuccess: '保存しました',
  customAddAction: '追加',
  customPlan: 'プラン',
  customPlanExpirationDate: '有効期限: {expirationDate}',
  customPlanDescription: 'プランを変更するには、Androidアプリケーション(AgriBus-NAVI)から行う必要があります。',
  customPlanOnly: 'スタンダードプラン専用の機能です',
  customDetail: '詳細',
  customDatePickerNullAlert: '先に日付を選択して下さい',
  customTaskNotFound: '作業履歴が見つかりません',
  customTaskNotFoundAtDate: '作業履歴が見つかりません。作業日：{date}',
  customErrorInitTasksFreePlan: 'フリープランでは最大2日分の履歴に限定されます',
  customErrorInitTasksNoTasks: '何も表示されない場合は、AgriBus-NAVIで「データの同期」をおこなってください！',
  customErrorInitFieldsNoFields: '圃場が一件も登録されていないか、AgriBus-NAVIで「データの同期」をおこなっていません。',
  customColored: '色分け',
  customHeight: '高度',
  customHeightMap: '高度マップ',
  customSpeed: 'スピード',
  customDate: '日時',
  customWorkWidth: '作業幅',
  customWorkedArea: '作業面積',
  customOverlappedArea: '重なり面積',
  customTaskRecordEfficiency: '作業効率',
  customDistance: '走行距離',
  customWorkedTime: '作業時間',
  customAverageSpeed: '平均スピード',
  customWorker: '作業者',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (平均 {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{fieldArea}中 {percentage}%',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',
  customPageSuffix: 'ページ',
  customDisplayCount: '表示件数',
  customTotalCount: '全 {count} 件',
  customListingModeSelf: '自分のみ',
  customListingModeAll: 'フォローを含む',
  customIconSettings: 'アイコン設定',
  customAccountHeader: 'アカウント',
  customConnectionHeader: 'つながり',
  customConnectionTitle: 'つながり',
  customFollowRequest: 'フォローリクエスト',
  customFollow: 'フォローする',
  customUnfollow: 'フォロー解除',
  customFollowing: 'フォロー',
  customFollower: 'フォロワー',
  customHaveNoFollowings: 'だれもフォローしていません',
  customHaveNoFollowers: 'フォロワーはいません',
  customInbox: '受信',
  customOutbox: '送信',
  customInboxEmpty: '受信したフォローリクエストはありません',
  customOutboxEmpty: '送信したフォローリクエストはありません',
  customSendFollowRequest: 'フォローリクエスト送信',
  customSendFollowRequestMessage: 'フォローリクエストを送信しました',
  customFollowRequestSelfRequestError: '自分自身にフォローリクエストは送信できません',
  customAllowFollowRequest: '{fromNickname}さんからのフォローリクエストを承認しました',
  customUnfollowMessage: 'フォローを解除しました',
  customUpdatedIconMessage: 'アイコンを変更しました',
  customIconNowSelected: '現在選択されています',
  customIcon: 'デフォルト',
  customIconSettingsDescription: 'ご自身のアイコンを設定することをオススメします。',
  customIconChangeToIcon: 'デフォルトに変更する',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'Gravatarにアイコンを設定している方はこちらを選択すると便利です。',
  customIconChangeToGravatar: 'Gravatarに変更する',
  customCustomIcon: 'カスタム',
  customIconSettingsCustomDescription: 'お好きな写真を設定できます。JPEGかPNGファイルを用意してください。',
  customIconChangeToCustom: 'カスタムに変更する',
  customIconReUpload: 'アップロードをやりなおす',
  customTemperature: '温度',
  customHumidity: '湿度',
  customWind: '風速',
  customPressure: '気圧',
  customSunrise: '日の出',
  customSunset: '日の入り',
  customShowAllCropsDescription: '全てを表示',
  customShowCurrentCropsDescription: '現在のみを表示',
  customProduct: '作付',
  customProductsNotFound: '作付が見つかりません',
  customColor: '色',
  customYear: '年',
  customCrop: '作物',
  customCropVariety: '品種',
  customDeleteCropConfirmationMessage:
    '{cropYear} {cropName} {cropVariety} を削除しますがよろしいですか？ （関連づけられたデータも削除されます）',
  customOperationType: '作業',
  customFilter: 'フィルター',
  customBillingPlan: '料金プラン',
  customBillingAndPayment: '料金・お支払い',
  customBillingMethod: 'お支払い方法',
  customBillingExistingCard: '登録済みのカード',
  customBillingAddNewCard: '新しいカードを追加',
  customBillingMethodConfirm: 'お支払い方法をご確認ください',
  customBillingHistory: '支払い明細',
  customCreditCard: 'クレジットカード',
  customCreditCardLast4: '末尾4桁',
  customCreditCardNameOnCard: 'カードに記載された名前',
  customCreditCardInfo: 'カード情報',
  customCreditCardAddCard: 'カードを追加',
  customCreditCardAddCardCaution1: '登録時点での請求はありませんが、今後のお支払い用のカードとして設定されます。',
  customCreditCardAddCardCaution2:
    '請求書払いをご希望の方は、カードを登録する前にcontact@agri-info-design.comまでご連絡ください。',
  customCreditCardNoCard: '登録されているクレジットカードがありません',
  customCreditCardDeleteFailure: 'カードの削除に失敗しました',
  customMyProducts: 'マイプロダクト',
  customMyProductsList: 'プロダクト一覧',
  customMyProductProduct: '製品',
  customMyProductProductNumber: '製品番号',
  customMyProductDataPlan: 'データプラン',
  customMyProductDataPlanSubscribe: 'データプラン契約',
  customMyProductDataPlanSubscribeSuccessMessage: 'まもなく {productNumber} の3G通信が有効になります。',
  customMyProductDataPlanExpiredMessage: '有効期限が {expiredDate} に切れました',
  customMyProductDataPlanCancelConfirmationMessage:
    '契約を解除すると、3G通信が無効になります。また、契約期間が残っている場合でも差額の返金はできません。ただし一度解除しても、もう一度契約し直すことは可能です。解除してもよろしいですか？',
  customRealTime: 'リアルタイム',
  customRealTimeSettings: 'リアルタイム設定',
  customModel: '機種',
  customSystemVersion: 'システムバージョン',
  customWebMarkerIcon: 'アイコン',
  customWebMarkerSetting: 'マーカー設定',
  customWebMarkerName: 'マーカー名',
  customWebMarkerColor: 'マーカーカラー',
  customRealtimeChooseYourDevice: 'デバイスを選択してください',
  customRealtimeDeviceNotActive: '現在稼働していません',
  customElevation: '標高',
  customGnss: 'GNSS',
  customSatellites: '衛星',
  customFirmwareVersion: 'ファームウェアバージョン',
  customHasFirmwareUpdate: '最新アップデートがあります',
  customFirmwareDownloadMessage: '新しいバージョン {newestFirmwareVersion} がリリースされています。',
  customDownload: 'ダウンロード',
  customFieldRegistration: '圃場の新規登録',
  customFieldCreateWithMapTitle: '地図上で圃場を作成',
  customFieldCreateWithMapTitleDescription: '地図上で圃場を新規作成します',
  customFieldCreateWithMapButton: '作成',
  customFieldCreateWithMapFieldName: '圃場名',
  customFieldCreateWithMapLoadingMap: '地図をロード中です',
  customFieldCreateWithMapCreate: '作成',
  customFieldCreateWithMapCreateFinishedMessage: '圃場 {fieldName} を作成しました',
  customFieldCreateWithMapCreateErrorMessage: '圃場 {fieldName} を作成できませんでした',
  customFieldCreateWithMapNoFieldMessage: '地図上で圃場を作成してください',
  customFieldCreateWithMapNoFieldNameMessage: '圃場名を入力してください',
  customFieldCreateWithMapTooManyFieldsMessage: '作成可能な圃場はひとつです',
  customFieldUploadTitle: 'KML/Shapefileのアップロード',
  customFieldUploadMessage: 'お手持ちのKML/KMZファイル、もしくはShapefileをアップロードしてください',
  customFileUploadShapefileDescription: 'Shapefileは以下のファイルを含んだZIPアーカイブ（圧縮）ファイルが必要です',
  customFieldUploadFileInput: 'ファイルを選択してください',
  customFileUploadShpDescription: '.shp（地形情報）',
  customFileUploadShxDescription: '.shx（インデックス情報）',
  customFileUploadDbfDescription: '.dbf（属性情報）',
  customFileUploadPrjDescription: '.prj（地理座標系情報）',
  customFileUploadPrjCaution: '.prj は座標情報を正しく読み取るために必要です。',
  customFileUploadTextEncodingDescription: ' 属性名などが文字化けする場合に変更してください',
  customFileUploadAttributeNameForFieldName: '圃場名として利用する属性名',
  customFileUploadFieldImportStart: '{count} 筆の圃場を取り込み開始',
  customFileUploadImportCheckTitle: '取り込む',
  customFileUploadFieldImportStartedMessage:
    '圃場を取り込み開始を開始しました。件数が多い場合は処理に数分かかる場合があります。',
  customFieldUploadErrorMessage: 'アップロードされたファイルを読み込むことができません',
  customFieldThisFieldName: '圃場「{fieldName}」',
  customFieldUnknownFieldName: 'この圃場',
  customFieldNoName: '圃場なし',
  customFieldDeleteAlertWithTask:
    '{fieldName}での作業履歴が {count} 件あります。削除をすると該当する作業履歴の圃場情報が失われてしまいますが、それでもよろしいですか？',
  customFieldDeleteAlertWithoutTask: '{fieldName}を削除してもよろしいですか？',
  customTextEncoding: 'エンコーディング',
  customFieldImportFinishedMessage: ' {count} 筆の圃場を取り込むことに成功しました',
  customFieldImportErrorMessage: '圃場の取り込みに失敗しました',
  customFieldCount: '圃場数: {count} 筆',
  customExport: 'エクスポート',
  customTaskExport: '作業履歴のエクスポート',
  customTaskWhatIsAgriBusFormat: 'AgriBusフォーマットはTAB区切りテキストですので、加工が容易です。',
  customTaskNowDeveloping: '開発中',
  customTaskNowDevelopingDescription: 'まもなく他のフォーマットでも出力ができるようになります。',
  customTaskStartExporting: 'エクスポート開始',
  customTaskNowExporting: 'エクスポート中...',
  customTaskDownloadReady: 'ダウンロードの準備ができました',
  customFieldHeader: '圃場',
  customDarkMode: 'ダークモード',
  customNewRegistration: '新規登録',
  customCreateNew: '新規作成',
  customImport: 'インポート',
  customListDisplay: 'リスト表示',
  customCardDisplay: 'カード表示',
  customCalendarDisplay: 'カレンダー表示',
  customFieldsList: '圃場一覧',
  customPleaseSignUpFromAndroidApplication:
    'Androidアプリ <span class="aid-logotype">AgriBus-NAVI</span> よりサインアップしてください。',
  customWhatIsAgribusNAVI: '<span class="aid-logotype">AgriBus-NAVI</span> とは',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> は、トラクターやコンバイン、自走式スプレーヤーなどの農業機械・農用車両に搭載して、圃場内の直進作業をお手伝いするAndroidOS用GPSガイダンス（GNSSガイダンス）アプリです。お手持ちのスマホ・タブレットにインストールして画面表示を確認しながら運転することで、広い圃場内でまっすぐ、等間隔に農作業を行うことができます。',
  customProductDetails: '製品情報を詳しく見る',
  aid: {
    calendar: {
      month: '月',
      week: '週',
      day: '日',
      fourDays: '4日',
    },
  },
  customTaskFilterAllSelect: '全ての作業',
  customTaskFilterGetError: 'フィルター情報の取得に失敗しました',
  customTaskFilterPostError: 'フィルター情報の登録に失敗しました',
  customTaskFilterPutError: 'フィルター情報の更新に失敗しました',
  customTaskFilterDeleteError: 'フィルター情報の削除に失敗しました',
  customTaskFilterPostSucceed: '「{filtername}」を登録しました',
  customTaskFilterPutSucceed: '「{filtername}」を更新しました',
  customTaskFilterSetDefault: '「{filtername}」をデフォルトのフィルターに設定しました',
  customTaskFilterDeleteSucceed: 'フィルター情報を削除しました',
  customTaskFilterSelectCheckError: '該当のフィルターが存在しません。フィルターを選択してください',
  customTaskFilterDuplicateCheckError: 'フィルター名が重複',
  customTaskFilterNotEnteredCheckError: 'フィルター名が未入力',
  customTaskFilterStringNarrowing: '文字列絞り込み',
  customTaskFilterMakeDefault: '常にこのフィルターを使用する',
  customTaskFilterName: 'フィルター名',
  customTaskFilterDeleteMsg: '「{filtername}」の削除を行いますか？',
  customTaskFilterDialogTitle1: '作業履歴にフィルターをかける',
  customTaskFilterDialogTitle2: '保存したフィルター設定を適用する',
  customTaskFilterCreateNew: '新しいフィルター設定を作成する',
  customTaskFilterEdit: 'フィルターを編集する',
  customTaskFilterSetting: 'フィルター設定',
  customTaskFilterCurrent: '現在のフィルター',
  customTaskFilterNoTasksError: 'フィルター「{filtername}」の設定により、表示件数が0件になっています。',
  customTaskFilterAreaZeroHidden: '作業面積（ぬりつぶし）ゼロの作業を除く',
  customTaskFilterDistanceUnderTenHidden: '走行距離が10m（10.936yd）未満の作業を除く',
  customTaskFilterNoField: '圃場がありません',
  customTaskFilterNoCrop: '作付けがありません',
  customTaskFilterOutOfFieldHidden: '圃場外の作業履歴を除く',
  customSimpleSignUpNow: '登録中...',
  customSimpleSignUpSuccess: '登録完了のためのメールを送信しました。メールボックスをご確認ください',
  customEnterpriseInviteSuccess: '招待メールを送信しました',
  customSimpleSignUpFailed: '登録に失敗しました',
  customSimpleSignUpUserAlreadyExists: 'メールアドレスに問題があります',
  customSimpleSignUpServerError: '登録プロセスでエラーが発生しました',
  customEnterpriseInvitingUser: 'このメールアドレスにはすでに招待を送り済みです',
  customDateFilterStartDate: 'フィルター開始日',
  customDateFilterEndDate: 'フィルター終了日',
  customDateFilterCalendarType: 'カレンダータイプ',
  customDateFilterCalendarTypeDate: '日',
  customDateFilterCalendarTypeMonth: '月',
  customDateFilterSetBotton: '設定する',
  customDateFilterRangeError: '開始日が終了日より未来の日付になっています。再度日付を選択してください。',
  customCurrency: '通貨',
  customBillingCurrencyJPY: '日本円',
  customBillingCurrencyUSD: '米ドル',
  customBillingMenu: 'ご利用プランの管理',
  customBillingMore: 'もっと詳しく',
  customBillingPurchase: '無料体験を30日間試す',
  customBillingPurchaseWithoutTrial: 'アップグレードする',
  customBillingPlanInfo: 'プラン情報',
  customBillingNowPlan: 'ご利用プラン',
  customBillingTrial: 'トライアル',
  customBillingCancellation: '解約',
  customBillingContractPeriod: '契約期間',
  customBillingAmount: '金額',
  customBillingAlertMustRegisterCard: '購入するためには、事前にクレジットカードの登録が必要です。',
  customBillingMessageUnsubscribe: '有料プランをキャンセルしました',
  customBillingMessageSubscribe: 'ご購入ありがとうございました',
  customBillingMessageUnSubscribeGoogle:
    '現在Google Play Storeでご契約頂いております。Google Play Storeで定期購入の解約を行ってください。',
  customBillingReceipt: '請求書 / 領収書',
  customBillingMessageCancelStandardPlan:
    '有料プランを解約しても、お支払済みの期間中はご利用できます。 ここで解約すると、{date}を過ぎると自動的にフリープランになりますが、それでもよろしいですか？',
  customBillingMessageCancelTrial:
    '現在トライアル期間ですが、ここで解約すると即座にフリープランに戻ります。解約後に新しく有料プランをご契約いただけますが、その際はトライアル期間が発生しないことにご注意ください。',
  customBillingStandardDescription:
    '有料プランは年額プランで1ヶ月無料。AgriBus-Webのデータ無期限保存や車両位置リアルタイム表示、AgriBus-NAVIの曲線ガイダンスや情報トレイなど、全ての機能を活用しよう！',
  customAdRow1_1: 'スタンダードプランで',
  customAdRow1_2: '農作業にデータ革命を。',
  customAdRow2_1: '3つの特典',
  customAdRow2_2: 'データの無制限保存とエクスポート',
  customAdRow2_3: '車両位置リアルタイム表示',
  customAdRow2_4: 'AgriBus-Casterの利用',
  customAdRow3_1: '3つの特典',
  customAdRow3_2: '高低差、走行速度などを作業軌跡に付加',
  customAdRow3_3: 'ガイダンス基準線の保存と呼び出し',
  customAdRow3_4: '曲線ガイダンスの適用',
  customOAuthMessage: '認証中...',
  customGoogleOAuthBtn: 'Googleでログインする',
  customGoogleOAuthSignUpBtn: 'Googleでサインアップする',
  customOAuthError: 'OAuth認証プロセスでエラーが発生しました',
  customOAuthGetUserInfoError: 'OAuth情報取得でエラーが発生しました',
  customOAuthServerError: 'OAuth認証情報登録プロセスでエラーが発生しました',
  customOAuthFailed: 'OAuth認証に失敗しました',
  customToBillingPage: 'スダンダードプラン購入画面へ',
  customTasksListFreePlanMsg:
    'フリープランでは、作業履歴は2日間のみの表示となります。スタンダードプランを購読することで、保存期間を無期限にすることができます。',
  customEnterprise: 'エンタープライズ',
  customEnterpriseSetting: 'エンタープライズ設定',
  customEnterpriseManagement: 'エンタープライズ管理',
  customWhatIsEnterprise: 'AgriBus-Web Enterpriseとは？',
  customEnterpriseRegistration: 'エンタープライズプランに登録',
  customPleaseContinueToRegisterForEnterprise:
    '届いたメールからAgriBus-Web Enterpriseへの登録手続きを引き続きお願いします。',
  customPleaseInputOrganizationName: 'あなたの組織名を入力してください。',
  customEnterpriseName: 'エンタープライズ名',
  customMaxOfMemberThisMonth: '今月の最大メンバー数',
  customExpectedPaymentAmountForThisMonth: '今月のお支払い予定額',
  customDateOfPayment: '支払日',
  customPaymentHistory: 'お支払い履歴',
  customEditEnterpriseName: 'エンタープライズ名の編集',
  customOrganization: '組織',
  customOrganizationName: '組織名',
  customAdministrator: '管理者',
  customOrganizationList: '組織一覧',
  customNewOrganization: '新しい組織の作成',
  customCreateOrganization: '組織を作成',
  customEditOrganizationName: '組織名の編集',
  customTeam: 'チーム',
  customTeamList: 'チーム一覧',
  customMyTeam: '所属チーム',
  customMyTeamList: '所属チーム一覧',
  customNewTeam: '新しいチームの作成',
  customTeamName: 'チーム名',
  customCreateTeam: 'チームを作成',
  customRemoveFromTeam: 'チームから削除',
  customEditTeam: 'チームの編集',
  customMember: 'メンバー',
  customMemberName: 'メンバー名',
  customAddNewMember: 'メンバーを追加',
  customNumberOfMember: '所属メンバー数',
  customInviteMembers: 'メンバーを招待する',
  customSendInvitationEmail: '招待メール送信',
  customPleaseEnterTheNameOfTheMember: '招待するメンバーの名前をご入力ください',
  customMemberList: 'メンバー一覧',
  customEditMember: 'メンバーの編集',
  customInviting: '招待中',
  customRestrictFollow: 'フォロー制限',
  customPermission: 'アクセス権限',
  customPermissionName: 'アクセス権限名',
  customRoleName: 'ロール名',
  customAction: 'アクション',
  customIndividualCreation: '個別作成',
  customConfirmTeamDeletion: 'このチームを削除してよろしいですか？',
  customConfirmMemberRemovalFromTeam: 'このメンバーをチームから削除してよろしいですか？',
  customSelectTeamsForMemberToJoinDialogTitle: 'メンバーが加入するチームを選択してください',
  customSelectTeamsForMemberToJoinDialogOK: '選択したチームに追加する',
  customSelectMembersAddToTeamDialogTitle: 'チームに加入するメンバーを選択してください',
  customSelectMembersAddToTeamDialogOK: '選択したメンバーを追加する',
  customFollowMembersDialogTitle: 'フォローするメンバーを選択してください',
  customFollowMembersDialogOK: '選択したメンバーをフォローする',
  customTeamFollowSelectDialogTitle: 'フォローするチームを選択してください',
  customTeamFollowSelectDialogOK: '選択したチームをフォローする',
  customPleaseConfirm: 'ご確認ください',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    '指定したメールアドレスのユーザーはスタンダードプラン、もしくはエンタープライズプランです。',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'スタンダードプランの場合は解約手続きを行ってからエンタープライズプランにご登録ください。',
  customEnterpriseSignUpForFreePlanDescription:
    '指定したメールアドレスのユーザーはフリープランです。エンタープライズプランに切り替えてよろしいですか？',
  customEnterpriseSignUpForStandardPlanDescription:
    '指定したメールアドレスのユーザーはスタンダードプランを解約しましたが、まだ有効期間中です。エンタープライズプランに切り替えますか？（スタンダードプランの支払いがまだ残っている場合、スタンダードプランとエンタープライズプランの両方で支払いが発生しますのでご注意ください。）',
  customAddFollowMembers: 'フォローメンバー追加',
  customAddFollowTeams: 'フォローチーム追加',
  customBillingMaxMember: '最大メンバー数',
  customCreditCardRegistration: 'クレジットカード登録',
  customNext: '次へ',
  customGoBackOneStep: '1つ前に戻る',
  customRestriction: '制限',
  customMemberSuspension: 'このメンバーを利用停止してよろしいですか？',
  customResumeMemberUsage: 'このメンバーの利用を再開してよろしいですか？',
  customRestart: '再開',
  customSuspended: '利用停止中',
  customAddToExistingTeam: 'チームに追加する',
  customFollowFunction: 'フォロー機能',
  customAllowToAddAndRemoveFollow: 'フォロー追加削除を許可',
  customAllowToAddAndRemoveFollowDescription:
    'このメンバーは、自分で自由にフォローを追加したり削除することが出来ないようになっています。',
  customNotAllowToAddAndRemoveFollow: 'フォロー追加削除を禁止',
  customNotAllowToAddAndRemoveFollowDescription:
    'このメンバーは、自分で自由にフォローを追加したり削除することが出来ます。',
  customEnterprisePlanDisplayName: 'エンタープライズプラン',
  customPricePerMember: '1メンバーあたりの料金です',
  customPerMember: 'メンバー1人につき',
  customNotesOnPlanSelection: '請求額は請求月内の最大メンバー数×単価です。',
  customDueDateForFirstRepayment: '初回支払予定日',
  customEnterprisePlanStart: '利用開始',
  customUnsubscribeFromEnterprise: 'エンタープライズプランから退会する',
  customReturnAgriBusWeb: 'Agri-Bus Webに戻る',
  customAboutCreditCardPayment: 'お支払いにご利用のクレジットカードについて',
  customClickHereUnsubscripbeFromEnterprise: 'エンタープライズプラン退会はこちらから',
  customEnterpriseWithdrawText1: '退会により、今月分のご請求が最後となり、以降のお支払いは発生いたしません。',
  customEnterpriseWithdrawText2:
    'これからもAgriBusシリーズ各製品は開発を続けて参りますので、ご縁がありましたら、またのぞいてみてください。',
  customEnterpriseWithdrawText3:
    '例えひと時であったとしても、AgriBusシリーズ各製品をご利用くださいましたこと、心より感謝申しあげます。ご利用ありがとうございました。',
  customErrorEnterpriseWithdraw: 'エンタープライズプランの解約に失敗しました。再度お試しください。',
  customGuidanceInterval: 'ガイダンス間隔',
  customWorkingWidth: '作業幅',
  customRefLineLength: '走行基準線長',
  customRefLine: '走行基準線',
  customExportRefLine: '走行基準線のエクスポート',
  customDirecton: '方位',
  customShowTaskDetailError:
    '作業履歴がありません。AgriBus-NAVIで同期されていない、もしくは削除された可能性があります。',
  customFileUploadAttributeNameForRefLineName: '走行基準線として利用する属性名',
  customFileUploadRefLineImportStart: '{count} 本の走行基準線を取り込み開始',
  customFileUploadShapefileDescriptionForRefLines:
    'Shapefileは以下のファイルのみで構成されたZIPアーカイブ（圧縮）ファイルが必要です',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp（地形情報）',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx（インデックス情報）',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf（属性情報）',
  customRefLineImportFinishedMessage: ' {count} 本の走行基準線を取り込むことに成功しました',
  customRefLineImportErrorMessage: '走行基準線の取り込みに失敗しました',
  customRefLineAddTitle: '走行基準線の新規登録',
  customRefLineImportTitle: 'Shapefileのアップロード',
  customRefLineImportText: 'お手持ちのShapefileをアップロードしてください',
  customRefLineImportText2: 'Trimble CFX-750から出力された走行基準線のみを取り込むことができます。',
  customRefLineCreateTitle: '地図上で走行基準線を作成',
  customRefLineCreateText: '地図上で走行基準線を作成します',
  customRefLineUploadTitle: '走行基準線のアップロード',
  customRefLineDeleteAlert: '{refLineName}を削除してもよろしいですか？',
  customRefLineDeleteUnknownName: 'この走行基準線',
  customRefLineDeleteKnownName: '走行基準線「{refLineName}」',
  customRefLineDeleteError: '走行基準線の削除に失敗しました',
  customThunderstormWithLightRain: '小雨による雷雨',
  customThunderstormWithRain: '雨と雷雨',
  customThunderstormWithHeavyRain: '大雨による雷雨',
  customThunderstormWithLightDrizzle: '軽い霧雨と雷雨',
  customThunderstormWithDrizzle: '霧雨と雷雨',
  customThunderstormWithHeavyDrizzle: '激しい霧雨を伴う雷雨',
  customThunderstormWithHail: 'ひょうと雷雨',
  customLightDrizzle: '小雨',
  customDrizzle: '霧雨',
  customHeavyDrizzle: '強い霧雨',
  customLightRain: '小雨',
  customModerateRain: '中程度の雨',
  customHeavyRain: '大雨',
  customFreezingRain: '着氷性の雨',
  customLightShowerRain: '軽いにわか雨',
  customShowerRain: 'にわか雨',
  customHeavyShowerRain: '強いにわか雨',
  customLightSnow: '小雪',
  customSnow: '雪',
  customHeavySnow: '大雪',
  customMixSnowRain: '雨混じりの雪',
  customSleet: 'みぞれ',
  customHeavySleet: '強いみぞれ',
  customSnowShower: 'にわか雪',
  customHeavySnowShower: '強いにわか雪',
  customFlurries: '粉雪',
  customMist: 'もや',
  customSmoke: '煙',
  customHaze: '煙霧',
  customSandDust: '砂塵',
  customFog: '霧',
  customFreezingFog: '霧氷',
  customClearSky: '晴天',
  customFewClouds: '曇り',
  customScatteredClouds: '曇り',
  customBrokenClouds: '曇り',
  customOvercastClouds: '曇り',
  customUnknownPrecipitation: '種別不明の降水',
  customWeatherInfoTitle: 'この作業時の気象データ',
  customWeatherDescriptionTitle: '天候',
  customWindSpeedTitle: '風速',
  customTemperatureTitle: '気温',
  customRelativeHumidityTitle: '湿度',
  customPrecipitationTitle: '降水量',
  customRefLineNameHint: '走行基準線名',
  customNumOfSatellites: '測位衛星数',
  customGnssStatus: 'GNSS状態',
  customLeftRightMisalignment: '左右のずれ',
  customAzimuthShift: '方位のずれ',
  customGradient: '傾斜度',
  customTimeOfAcquisition: '取得時刻',
  customWorkOverview: '作業概要',
  customImageStorage: '画像保存',
  customMapGaugeDescriptionNone: '色分けの無い作業の塗りつぶしが表示されます',
  customMapGaugeDescriptionHeight: '作業の高低差が色別に表示されます',
  customMapGaugeDescriptionSpeed: '作業の速度が色別に表示されます',
  customMapGaugeDescriptionNumOfSatellites: '作業時の測位衛星数が色別に表示されます',
  customMapGaugeDescriptionGnssStatus: '作業時のGNSS状態が色別に表示されます',
  customMapGaugeDescriptionLeftRightMisalignment: '作業時のガイダンスとの左右のずれが色別に表示されます',
  customMapGaugeDescriptionAzimuthShift: '作業時のガイダンスとの方位のずれが色別に表示されます',
  customMapGaugeDescriptionGradient: '作業時の傾斜度が色別に表示されます（G2,GMiniR,Gminiのみ）',
  customWeathercomTornado: '竜巻',
  customWeathercomTropicalStorm: '熱帯暴風雨',
  customWeathercomHurricane: '台風',
  customWeathercomStrongStorms: '強烈な嵐',
  customWeathercomThunderstorms: '雷雨',
  customWeathercomRainSnow: '雨 雪',
  customWeathercomRainSleet: '雨みぞれ',
  customWeathercomWintryMix: 'みぞれ',
  customWeathercomFreezingDrizzle: '凍てつく霧雨',
  customWeathercomDrizzle: '霧雨',
  customWeathercomFreezingRain: '凍てつく雨',
  customWeathercomShowers: 'にわか雨',
  customWeathercomRain: '雨',
  customWeathercomFlurries: '軽く降る雪',
  customWeathercomSnowShowers: 'にわか雪',
  customWeathercomBlowingDriftingSnow: '吹雪',
  customWeathercomSnow: '雪',
  customWeathercomHail: 'ひょう',
  customWeathercomSleet: 'みぞれ雪',
  customWeathercomBlowingDustSandstorm: '吹雪',
  customWeathercomFoggy: '霧の中',
  customWeathercomHaze: '煙霧',
  customWeathercomSmoke: '煙',
  customWeathercomBreezy: 'そよ風',
  customWeathercomWindy: '強風',
  customWeathercomFrigidIceCrystals: '凍てつく氷の結晶',
  customWeathercomCloudy: '曇り',
  customWeathercomMostlyCloudy: 'ほとんど曇り',
  customWeathercomPartlyCloudy: '一部曇り',
  customWeathercomClear: '晴天',
  customWeathercomSunny: '晴れ',
  customWeathercomFairMostlyClear: '快晴',
  customWeathercomFairMostlySunny: '快晴',
  customWeathercomMixedRainandHail: '雨霰',
  customWeathercomHot: '猛暑',
  customWeathercomIsolatedThunderstorms: '一部雷雨',
  customWeathercomScatteredThunderstorms: '一部雷雨',
  customWeathercomScatteredShowers: 'にわか雨',
  customWeathercomHeavyRain: '大雨',
  customWeathercomScatteredSnowShowers: 'にわか雪',
  customWeathercomHeavySnow: '大雪',
  customWeathercomBlizzard: '吹雪',
  customWeathercomNotAvailable: '天気を取得できませんでした',

  customSharedMountPointSetting: 'マウントポイント設定',
  customSharedMountPointSettingTitle: '組織内で共有するRTK基準局のマウントポイントを設定します。',
  customSharedMountPoint: '共有マウントポイント',
  customMountPoint: 'マウントポイント',
  customStatus: 'ステータス',
  customNotSet: '設定されていません',
  customSelectMountPoint: 'マウントポイントを選択',
  customUnsharedMountPoint: '共有を解除',
  customSelectMountPointTitle: '共有するマウントポイントを選択してください',
  customSharedMountPointRemarks1:
    'マウントポイントは、AgriBus-GToolsアプリを使用してAgriBus-GMiniRを基準局設定すると発行されます。他社製基準局をご使用の方は下記リンクより申請してください。',
  customSharedMountPointRemarks2: '申請はこちらから',
  customOnline: 'オンライン',
  customOffline: 'オフライン',
  customNotIssued: '未発行',
  customSetItUp: '設定しました',
  customDeActivated: '解除しました',
  customType: '種別',
  customCropIsNotRegistered: '作付が登録されていません',
  customNameNotRegistered: '名称未登録',

  customGoToPayerManager: '管理画面を開く',
  customPaymentInfo: 'お支払い情報',
  customProjectInfo: 'プロジェクト情報',
  customAddProject: 'プロジェクト追加',
  customAddProjectRemarks: 'プロジェクト名と管理者のメールアドレスを指定してください',
  customProjectName: 'プロジェクト名',
  customProjectAdminMailAddress: '管理者メールアドレス',
  customStop: '停止',
  customStopDialogText: '選択したプロジェクトを削除いたしますか？',
  customDone: '完了しました',
  customUpdateDay: '更新日',
  customAdminName: '管理者名',
  customMaxQuantity: '最大人数',
  customaddProjectSuccess: 'プロジェクトの追加が完了いたしました。',
  customPlantingShowPast: '過去の作付を表示',
  customPlantingHidePast: '過去の作付を隠す',
  customPlantingCropDisplayName: '作物表示名',
  customPlantingCropVarietyName: '品種名',
  customPlantingSeason: '栽培期間',
  customPlantingSeasonStartDate: '開始日（必須）',
  customPlantingSeasonEndDate: '終了日',
  customPlantingAddCropOption: '作物オプション追加',
  customPlantingRemoveCropOption: '作物オプション削除',
  customPlantingCropSelectionRequiredError:
    '必ず選択してください。該当するものがない場合は「その他」を選んでください。',
  customPlantingOtherCropSelectionRequiredError: '「その他」を選んだ場合は必ず入力してください',
  customPlantingDeleteConfirmationMessage:
    "{plantingName} を削除しますがよろしいですか？ （関連づけられたデータも削除されます）'",
  customPlantingFieldSelectionHint: '圃場名が設定されていないと、ここのリストには表示されません',

  customTaskDeleteMessage: '選択した作業を削除してもよろしいですか？',
  customTaskDeleteFailure: '選択した作業の削除に失敗しました',
  customTaskDeleteSucceed: '選択した作業の削除に成功しました',

  customErrorStartDateRequired: '開始日は必須です',
  customErrorFieldRequired: '圃場は必須です',

  customAlreadyExistingUser: '既に登録済みのメールアドレスです。未登録のメールアドレスをご使用ください。',

  customNowProgressRateTitle: '作業進捗',
  customNowProgressRateNotField: '該当圃場なし',

  customStandardSubscribeErrorMessage: 'サブスクリプションの購入に失敗いたしました。入力された情報を再度ご確認下さい。',
  customStripeCouponText1: 'クーポンを利用する場合はこちら',
  customStripeCouponText2: 'クーポンコードはこちらへ',

  customUpdatePolygonFailure: '圃場の更新に失敗しました。',

  customMultiPolygonImportError:
    'MultiPolygonが含まれたデータです。MultiPolygonには対応していないのでPolygonに変換してください。',

  customSimpleSignUpAndSignInError: 'メールアドレス、またはパスワードに問題があります。ご確認ください。',
  customNewPasswordValidationError: '英字小文字、数字が少なくとも一つずつ必要です。',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: '支払方法の選択',
  customCardInfoHasNotBeenEnteredError: 'カード情報を入力してください',
  customNoPaymentMethodSeletedError: '支払方法が選択されていない',
  customFreeDashBoardText1: 'AgriBus-Webにログインするには、有料プラン（AgriBus Professional）の購読が必要です。',
  customFreeDashBoardText2: '詳細は',
  customFreeDashBoardText3: 'お知らせ',
  customFreeDashBoardText4: 'をご覧ください。',
  customContractPlanTitle: 'ご契約プラン',
  customComparePlansText: 'プランを比較する',
  customUpgradeToPlusText: 'Plusにアップグレード',
  customDowngradeToPlusText: 'Plusにダウングレード',
  customUpgradeToProfessionalText: 'AgriBus Professionalにアップグレード',
  customBillingBillingText1: '解約済み - 有効期限が切れましたらFreeプランに自動的に変更されます。',
  customUpgradeConfirematoinText: 'AgriBus Professionalへアップグレードいたします。よろしいでしょうか？',
  customDowngradeConfiremationText: 'Plusへダウングレードいたします。よろしいでしょうか？',
  customBankTransfer: '銀行振込',
  customHome: 'ホーム',
  customBillingMessageSubscribeGoogle:
    '現在Google Play Storeでご契約頂いております。Google Play Storeで定期購入のアップグレード/ダウングレードを行ってください',
  customInvoiceReceiptAddresseeTitle: '請求書/領収書宛名',
  customChangeAddresseeBtnText: '宛名を変更する',
  customBillingEmailAddressTitle: '請求先メールアドレス',
  customChangeBillingEmailAddressText: '請求先メールアドレスを変更する',
  customCannotDowngradeText: '銀行振込の場合はPlusへダウングレードできません',
  customChangePaymentMethodsToCard: 'カード払いに変更する',
  customChangePaymentMethodsToCustomerBalance: '銀行振込に変更する',
  customChangePaymentMethodToSendInvoiceText: '支払方法を銀行振込に変更してよろしいでしょうか？',
  customMapGaugeDescriptionColorCodedFill: 'アプリで色別塗りつぶしを行った場合色分けした作業履歴が表示されます',
  customColorCodeFill: '色別塗りつぶし',
  customSelectDefaultIconTitle: 'アイコンを選択してください',
  customImportLimitMessage: 'インポートは最大{limit}件までです。',
  customPresetIcon: {
    title: 'プリセット',
    description: '6種類のプリセットからお選びいただけます。',
    btnText: 'プリセットから選択する',
  },
  customBulkDeleteCheckboxText: '一括削除',
  customBulkDeleteDialogText: '一括削除を行なってよろしいでしょうか？',
  customPerimeter: '外周',
  feed: {
    menu: 'フィード',
    title: 'ニュースフィード',
    description: '地域の農作業の動き(匿名統計)と産地情報を毎日お届けします。',
    yourArea: 'あなたのエリアの作業活動 (約33km)',
    areaFromFields: '圃場の位置から自動判定',
    widerArea: '広域の作業活動 (約55km)',
    national: '全国の作業活動',
    daily: '前日',
    weekly: '直近7日',
    monthly: '直近28日',
    vsNormal: '対平年比',
    vsLastYear: '対前年比',
    noData: 'このエリアはデータ不足のため表示できません (近隣の作業情報が少ないため)。',
    noAreaHint: '圃場を登録すると、あなたのエリアの統計が表示されます。',
    nationalFallback: '全国の統計を下に表示しています。',
    upsell: '有料プランでは、前日までの最新データ・直近28日データ・広域 (約55km) の表示が追加されます。',
    monitorTitle: '産地モニター週報',
    monitorActive: '観察パターン点灯中',
    monitorNone: '観察パターンなし',
    toMarketInsights: 'マーケット情報を見る',
    loadError: 'フィードを読み込めませんでした。時間をおいて再度お試しください。',
    disclaimer: '地域の活動量は匿名統計であり、個々の営農の評価ではありません。',
    kindNews: 'お知らせ',
    kindPr: 'PR',
    readMore: '詳しく見る',
    entryDaily: '{date} の作業活動',
    entryWeekly: '週間サマリー (〜{date})',
    areaC3: 'あなたのエリア',
    areaC5: '広域',
    areaJp: '全国',
    historyTitle: '過去の動向',
    kindSignal: 'シグナル',
    shareTitle: 'フィードで共有',
    share: '共有',
    shareVisibility: '公開範囲',
    visFollowers: 'フォロワーのみ',
    visNeighborhood: '近隣に公開',
    visPublic: '全体に公開',
    shareRoute: '作業経路を表示する',
    shareExact: '正確な位置も公開する(地図背景で表示)',
    statTime: '時間',
    statDistance: '距離',
    statArea: '面積',
    statWidth: '作業幅',
    statSpeed: '速度',
    statGnss: 'GNSS',
    shareComment: 'コメント',
    shareSubmit: '共有する',
    sharePosted: '共有しました',
    shareFailed: '操作できませんでした。時間をおいて再度お試しください。',
    consentNote: '投稿は選択した公開範囲のユーザーに表示されます。位置はおよその地域(約11km)単位でのみ表示されます。',
    consentLabel: '共有機能の利用規約(第15条の2)に同意します',
    postDelete: '削除',
    postDeleted: '投稿を削除しました',
    postDeleteConfirm: 'この投稿を削除しますか?',
    report: '通報',
    reportTitle: '投稿を通報',
    reportConfirm: 'この投稿を運営に通報しますか?',
    reportReason: '理由 (任意)',
    reportDone: '通報しました。ご協力ありがとうございます',
    visPrivate: '自分のみ',
    followRequested: 'リクエスト中',
    followAccept: '承認',
    followDecline: '拒否',
    followAccepted: 'フォローリクエストを承認しました',
    unfollow: 'フォロー解除',
    unfollowConfirm: 'フォローを解除しますか?',
    connectionsHint: 'フィードの投稿からフォローリクエストを送れます。承認されるとフォロワー限定の投稿が見られます',
    sharePhotos: '写真を追加 (最大4枚)',
    sharePhotosHint: '写真の位置情報 (EXIF) は自動的に削除されます',
    snsShare: 'シェア',
    copyLink: 'リンクをコピー',
    linkCopied: 'リンクをコピーしました',
    shareOther: 'その他のアプリ',
    instagramSaved: 'カード画像を保存しました。Instagramアプリから投稿してください',
    manualRecords: '手動記録',
    addManualRecord: '手動記録を追加',
    manualChip: '手動',
    recordStart: '開始日時',
    recordEnd: '終了日時',
    recordMemo: 'メモ',
    recordDuration: '作業時間 (分)',
    recordCreated: '記録を追加しました',
    recordDeleteConfirm: 'この記録を削除しますか?',
    noManualRecords: '手動記録はまだありません',
    poiRecords: '地点メモ',
    addPoi: '地点メモを追加',
    poiTitle: 'タイトル',
    poiMapHint: '地図をクリックして地点を指定できます。未指定の場合は写真の位置情報を使用します',
    noPoiRecords: '地点メモはまだありません',
    map: 'マップ',
    mapLayers: 'レイヤー',
    editMode: '編集モード',
    selected: '選択中',
    mergeSave: 'マージ保存',
    clipDraw: 'クリップ範囲を描く',
    saveAsField: '作付けエリアを圃場として保存',
    workWidthM: '作業幅 (m)',
    workName: '名称',
    workSaved: '派生記録を保存しました',
    derivedRecords: '派生記録',
    derivedChip: '派生',
    derivedDeleteConfirm: 'この派生記録を削除しますか?',
    saveRangeAsWork: '選択区間を派生記録として保存',
    clipByField: '圃場でクリップ',
    showOnMap: 'マップで表示',
    editRange: '区間を編集',
    trajectoryChip: '走行',
    derivedRecordsDescription:
      '走行・移動軌跡ごとに一対で生成される作業記録です。編集した記録 (マージ/クリップ/区間) と手動記録もここに並びます',
    spatialEdit: 'クリップ・圃場化',
    vraTitle: '可変施肥マップ',
    vraDescription: '衛星画像の植生指数から可変施肥 (VRA) 用のマップを生成します',
    vraGenerate: '新規マップ生成',
    vraIndex: '植生指数',
    vraGridSize: 'グリッド (m)',
    vraDirection: '方位 (度)',
    vraCloudPct: '雲量上限 (%)',
    vraImages: '使用画像数',
    vraFailed: '生成に失敗しました。期間内に雲のない衛星画像がない可能性があります',
    saveFailed: '保存に失敗しました',
    mapSetGenerated: '生成が完了しました',
    fieldValidFromDate: '有効開始: {date}',
    fieldDeleteLinked: '{fieldName}は次のデータに紐づいているため削除できません。',
    fieldDeleteLinkedTasks: '作業履歴: {count} 件',
    fieldDeleteLinkedSets: '圃場セット: {names}',
    fieldDeleteLinkedHint: '削除するには、先に紐づいている作業履歴や圃場セットを削除・解除してください。',
    elevSource: '生成ソース',
    elevSourceDem: '衛星標高 (DEM)',
    elevSourceGnss: '作業履歴 (GNSS)',
    elevCenter: '色分けの中心',
    elevCenterMean: '平均値',
    elevCenterMedian: '中央値',
    elevCenterValue: '中心標高',
    elevCustom: '任意',
    elevRange: '色分けの範囲',
    elevRangeWidth: 'レンジ幅',
    elevContour: '等高線',
    zoneBands: '段数',
    zonePalette: '色系統',
    paletteHue: 'HSI (緑→黄→赤)',
    paletteYlgn: '黄→緑',
    paletteGnrd: '緑→赤',
    reclassifyTitle: '段数・色分けの変更 (再生成不要)',
    reclassifyApply: '再分類を適用',
    followByEmail: 'メールアドレスでフォローリクエスト',
    emailUserNotFound: 'このメールアドレスのユーザーが見つかりません',
    followRequestSent: 'フォローリクエストを送信しました',
    eventSettingsTitle: 'フィード設定 (イベント自動投稿)',
    eventSettingsVisibility: 'イベントの公開範囲',
    eventSettingsLocation: '位置情報の公開範囲',
    eventSettingsSnsStrip: 'SNS共有時に絶対位置情報を削除する (既定)',
    eventSettingsPrefs: 'フィードにアップするイベント',
    locHidden: '公開しない',
    locApprox: 'おおまかな位置 (約10kmメッシュ)',
    locExact: '絶対位置を含める',
    event_work_start: '作業開始',
    event_work_end: '作業終了',
    event_field_enter: '圃場に入った',
    event_field_exit: '圃場から出た',
    event_poi_added: '地点メモ追加',
    event_vra_map_added: '可変施肥マップ追加',
    event_elevation_map_added: '高低差マップ追加',
    event_refline_added: '基準線追加',
    event_field_added: '圃場追加',
    event_field_set_added: '圃場セット追加',
    event_work_start_text: 'が作業を開始しました ({name})',
    event_work_end_text: 'が作業を終了しました ({name})',
    event_field_enter_text: 'が圃場「{name}」に入りました',
    event_field_exit_text: 'が圃場「{name}」から出ました',
    event_poi_added_text: 'が地点メモ「{name}」を追加しました',
    event_vra_map_added_text: 'が可変施肥マップ「{name}」を作成しました',
    event_elevation_map_added_text: 'が高低差マップ「{name}」を作成しました',
    event_refline_added_text: 'が基準線を追加しました ({name})',
    event_field_added_text: 'が圃場「{name}」を追加しました',
    event_field_set_added_text: 'が圃場セット「{name}」を作成しました',
    vraNameAuto: '名称 (空欄なら自動: 圃場名+指数+日付)',
    eventPrefOff: 'アップしない',
    visEditTitle: '公開設定の変更',
    visEditLocationExact: '正確な位置を表示 (地図背景)',
    visEditRemoveLocation: '絶対位置情報を削除する',
    visEditPublicNote: '全体公開では絶対位置情報は自動的に除外されます',
    consentRequiredToShare:
      '共有には利用規約 (共有機能) への同意が必要です。まず通常の投稿から共有を有効にしてください',
    elevGnssFailed:
      '高低差の算出に失敗しました。指定条件に合う作業履歴 (GNSS標高) が見つからないか、まだ計算中です。GNSS状態フィルターや日付範囲を緩めてお試しください',
    elevDescription:
      '作業履歴のGNSS標高 (RTK推奨) から圃場の高低差マップを生成します。作業履歴がない場合は衛星標高データ (DEM) も使えます。可変施肥マップと同じ仕組みでNAVIに同期できます',
    fieldValidUntil: '有効期限: {date}',
    mapSetGeneratedWithCount: '生成 {created} 件 / 失敗 {failed} 件 (同じ圃場の既存マップは置き換えられます)',
    vraGenerating: '衛星画像を解析中...',
    vraObsDate: '観測日',
    vraPeriodMean: '期間平均',
    vraLimitReached: '生成回数の上限に達しました (Freeプランは累計3回・有料プランは1日10回)',
    vraExport: 'ISOXMLエクスポート',
    vraModeGrid: 'メッシュ (グリッド)',
    vraModePolygon: 'ポリゴン',
    vraRate: '施肥量 (kg/ha)',
    vraCellSize: 'セルサイズ (m)',
    vraEditMap: '編集',
    mapSets: '圃場セット',
    mapSetDescription:
      '圃場フィルタ (有効期間・作目・名称) で圃場をまとめます。可変施肥マップの一括生成などで利用できます',
    mapSetCreate: '圃場セット作成',
    fieldSetEmpty: '圃場セットはまだありません',
    mapSetTargetDate: '対象日',
    mapSetCrop: '作目',
    mapSetNameContains: '圃場名 (含む)',
    mapSetMemoContains: 'メモ (含む)',
    mapSetPreviewCount: 'マッチする圃場',
    mapSetGenerate: '生成/更新',
    mapSetFields: '圃場数',
    mapSetLastGenerated: '最終生成',
    fieldAttrsTitle: '圃場属性 (有効期間・作目)',
    fieldValidFrom: '有効開始 (空欄=無期限)',
    fieldValidTo: '有効終了 (空欄=無期限)',
    mapSetNoMatch: '条件に合う圃場がありません',
    mapSetDeleteConfirm: 'この圃場セットと、このセットから生成した可変施肥マップを削除しますか?',
    trajectories: '走行・移動軌跡',
  },
  marketInsights: {
    menu: 'マーケット情報',
    title: 'マーケット情報 (AgriBus-DWH)',
    description:
      '世界の大豆・小麦主要産地の作業進捗と市況の観察材料を毎日確認できます。皆さまの作業データ (匿名統計) を、出荷判断などに使える情報としてお届けする会員特典です。',
    soybeanDescription: 'ブラジル・米国の大豆産地の作況と市況観察シグナル',
    wheatDescription: '小麦産地の作況と市況観察シグナル',
    open: '開く',
    upsell: 'マーケット情報は有料プランの会員特典です。有料プランにご加入いただくと追加費用なしで閲覧できます。',
    memberNote: '会員として閲覧中はモニター画面の左上にバッジが表示されます。本情報は投資推奨ではありません。',
  },
}
